import { useQuery } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useViewPastPaper = (
  country_id,
  exam_board_id,
  subject_id,
  level,
  year,
  page
) => {
  const formData = {};
  if (country_id) formData.country_id = country_id;
  if (exam_board_id) formData.exam_board_id = exam_board_id;
  if (subject_id) formData.subject_id = subject_id;
  if (level) formData.level = level;
  if (year) formData.year_id = year;
  if (page) {
    formData.pagination = true;
    formData.page = page;
  }
  return useQuery(
    ["pastPapers", country_id, exam_board_id, subject_id, level, year, page],
    async () => {
      const { data } = await axiosPost("/api/cw/viewPastPaper", formData);
      return data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useViewPastPaper;

//id:151
//country_id:3
//exam_board_id:2
//year_id:12
//subject_id:3
// pagination:true
// page:1
// per_page:50
